module.exports = __webpack_public_path__ + "0baf5da99de51cb72ad3d2784ffacc98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-realisations/les-aliments-bercy/02.jpg
// module id = XMS9
// module chunks = 0